import { FilteredCongestionReportsParagraphProps } from 'components/CongestionReportsParagraph';
import {
  Box,
  ButtonLink,
  Divider,
  GridItem,
  PageGrid,
  RichText,
  Stack,
} from '@ads-core/components';
import { isPublished } from 'src/utils/isPublished';

import { CongestionTable } from './_CongestionTable';
import { Attachment } from './_Attachment';
import { PreAnnouncementText } from './_PreAnnouncementText';
import { getAssetData } from './utils/getAssetData';
import { CongestionManagement } from './_CongestionManagement';

export type CongestionReportsParagraphViewProps = FilteredCongestionReportsParagraphProps;

export const CongestionReportsParagraphView = (props: CongestionReportsParagraphViewProps) => {
  const assetData = getAssetData(props);

  if (!assetData) return null;

  const {
    attachmentText,
    attachmentTitle,
    availableCapacityHigherThanRequiredCapacityText,
    capacityTextFirstPart,
    capacityTextSecondPart,
    congestionManagementText,
    expressInterestButton,
    expressInterestText,
    howAndWhenText,
    introText,
    notableAspectsText,
    researchApplicableText,
    reportDates,
  } = assetData;
  const congestionReport = props.congestionReport;
  const isCongestionManagementPublished = isPublished(
    congestionReport?.congestionManagementPublicationDate
  );

  const toggleCongestionManagement =
    isCongestionManagementPublished &&
    Boolean(
      researchApplicableText ||
        congestionReport?.contentServerLink ||
        congestionReport?.congestionManagementResearchSummary
    );

  return (
    <PageGrid>
      <GridItem columnStart={{ initial: '1', md: '3' }} columnEnd={{ initial: '-1', md: '-3' }}>
        <Stack gap={10}>
          <Stack gap={8}>
            {introText ? <RichText>{introText}</RichText> : null}
            {capacityTextFirstPart ? <RichText>{capacityTextFirstPart}</RichText> : null}
            {availableCapacityHigherThanRequiredCapacityText ? (
              <RichText>{availableCapacityHigherThanRequiredCapacityText}</RichText>
            ) : null}
            {capacityTextSecondPart ? <RichText>{capacityTextSecondPart}</RichText> : null}
          </Stack>
          {congestionReport?.underlyingAssets?.length || assetData.mainAsset ? (
            <CongestionTable
              underlyingAssets={congestionReport?.underlyingAssets}
              mainAsset={assetData.mainAsset}
            />
          ) : null}
          {howAndWhenText ? <RichText>{howAndWhenText}</RichText> : null}
          {congestionReport?.preAnnouncement ? (
            <PreAnnouncementText
              mainText={notableAspectsText}
              announcementTexts={congestionReport?.preAnnouncement}
            />
          ) : null}
          {!toggleCongestionManagement && congestionManagementText ? (
            <RichText>{congestionManagementText}</RichText>
          ) : null}
          {toggleCongestionManagement ? (
            <CongestionManagement
              congestionManagementTitle={props?.congestionManagementTitle?.toString() || undefined}
              reportDates={reportDates}
              researchApplicableText={researchApplicableText}
              congestionReport={{
                congestionManagementResearchSummary:
                  congestionReport?.congestionManagementResearchSummary || undefined,
                contentServerLink: congestionReport?.contentServerLink || undefined,
              }}
            />
          ) : null}
          <Divider />
          {expressInterestButton || expressInterestText ? (
            <Stack gap={8}>
              <RichText>{expressInterestText}</RichText>
              {expressInterestButton?.href ? (
                <Box>
                  <ButtonLink {...expressInterestButton}>{expressInterestButton.text}</ButtonLink>
                </Box>
              ) : null}
            </Stack>
          ) : null}
          {attachmentTitle && attachmentText ? (
            <Attachment title={attachmentTitle} text={attachmentText} />
          ) : null}
        </Stack>
      </GridItem>
    </PageGrid>
  );
};
